import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './app';
import { StoreProvider } from './contexts/store-provider';
import IntlProviderNew from './translations/intl-provider';
import { unregister } from './serviceWorker';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <StoreProvider>
    <IntlProviderNew>
      <HelmetProvider>
        <Router>
          <App />
        </Router>
      </HelmetProvider>
    </IntlProviderNew>
  </StoreProvider>
);

unregister();
